
// ROUTES
require('modules/room/routes/room');

// CONTROLLERS
require('modules/room/controllers/room');
require('modules/room/controllers/list');
require('modules/room/controllers/create');
require('modules/room/controllers/edit');

// SERVICES
require('modules/room/services/room');
require('modules/room/services/list');
require('modules/room/services/create');
require('modules/room/services/edit');
require('modules/room/services/delete');


angular.module('unica_room', [

	// ROUTES
	'unica_room.room_routes',

	// CONTROLLERS
	'unica_room.room_controllers',

	// SERVICES
	'unica_room.room_services'

]);